import fetch from '../../utils/fetch';
import { API_ROUTES } from '../../utils/constants';
import { getUserToken } from '../../utils/helpers';

export const uploadMediaAPI = (data) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${accessToken}`,
  };
  const formData = new FormData();
  formData.append('app', data.app);
  formData.append('campaigns', data.campaigns);
  formData.append('author', data.author);
  data.selectedMedias.forEach((media) => {
    formData.append('file', media);
  });
  return fetch({
    method: 'POST', route: API_ROUTES.MEDIA, data: formData, requestHeaders: headers, basic: false,
  });
};


export const deleteMediaAPI = (id) => {
  const accessToken = getUserToken().access_token;
  const headers = {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${accessToken}`,
  };
  return fetch({
    method: 'DELETE', route: `${API_ROUTES.MEDIA}/${id}`, requestHeaders: headers, basic: false,
  });
};



// WEBPACK FOOTER //
// ./src/reducers/media/api.js